'use strict';

import {irregularityModel} from "../../models/irregularitymodel.js";
import {applicableMeasureModel} from "../../models/applicablemeasuremodel.js";

export class IrregularityEditCtrl
{
	model;
	
	classif;
	
	attachments = [];
	
	uploadTs = 0;
	
	allMeasures = [];
	
	beneficiaries = [];
	
	$filter;
	
	constructor($scope, $http, $filter, $mdDialog, jsDataService){
		this.$scope = $scope;
		this.$http = $http;
		this.$filter = $filter;
		this.$mdDialog = $mdDialog;
		this.jsDataService = jsDataService;
		this.model = jsDataService.get('irregularity');
		this.classif = jsDataService.get('cfgClassif');
		this.model = new irregularityModel(jsDataService.get('irregularity'), $filter, this.jsDataService);	
		
		if(parseInt(this.model.date) > 0){
			this.model.date = new Date(parseInt(this.model.date) * 1000);
		} else {
			this.model.date = '';
		}
		
		if(parseInt(this.model.decision_date) > 0){
			this.model.decision_date = new Date(parseInt(this.model.decision_date) * 1000);
		} else {
			this.model.decision_date = '';
		}
		
		if(parseInt(this.model.measures_completion_date) > 0){
			this.model.measures_completion_date = new Date(parseInt(this.model.measures_completion_date) * 1000);
		} else {
			this.model.measures_completion_date = '';
		}
		
		jsDataService.set('autosave', {on: true, url: jsDataService.get('cfgSaveUrl')});
		
		this.beneficiaries = jsDataService.get('beneficiaries');
		this.allMeasures = this.model.applicable_measures;
		this.setApplicableMeasures();
	}
	
	setApplicableMeasures() {
		this.model.applicable_measures = [];
		
		for(let ln of this.allMeasures){
			if(!this.model.applicable_measures_ids.includes(ln.measure)) {
				continue;
			}
			
			this.model.applicable_measures.push(new applicableMeasureModel(ln, this.$filter, this.jsDataService));
		}
	}
	
	submit(e) {
		console.log(this.model);
		
		if(this.jsDataService.get('cfgSaveUrl')){
			this.$scope.basicHttpConfigProcess({
				url: this.jsDataService.get('cfgSaveUrl'),
				method: 'POST',
				data: this.model
			}).then((response) => {
				console.log(response);
			}, (err) => {
				console.log(err);
			});
		}
	}
	
	onMeasuresUpdate(event){
		this.setApplicableMeasures();
	}
	
	autosavePostFields() {
		const measures = [...this.model.applicable_measures].map((measure) => {
			return {id: measure.id, measure: measure.measure, description: measure.description};
		})
		
		const data = {
			date: this.model.date,
			audit_observation: this.model.audit_observation,
			audit_observation_description: this.model.audit_observation_description,
			suspected_description: this.model.suspected_description,
			grant_agreement_suspension: this.model.grant_agreement_suspension,
			payment_deadline_suspension: this.model.payment_deadline_suspension,
			has_irregularity_detected: this.model.has_irregularity_detected,
			decision_date: this.model.decision_date,
			conclusion: this.model.conclusion,
			payment_deadline_suspension: this.model.payment_deadline_suspension,
			measures_completion_date: this.model.measures_completion_date,
			comment: this.model.comment,
			applicable_measures: measures,
			section_1_attachment: this.model.section_1_attachment,
			section_2_attachment: this.model.section_2_attachment,
			selected_beneficiaries: this.model.selected_beneficiaries,
		};
		
		return data;
	}
	
	onAttachmentUpload(field, file){
		if(field === 'section_1'){
			this.model.section_1_attachment.push({title: file.file_name, file_id: file.file_id});
		} else if(field === 'section_2'){
			this.model.section_2_attachment.push({title: file.file_name, file_id: file.file_id});
		}
		this.$scope.editForm['upload_ts'].$setViewValue(Date.now());
//		this.uploadTs = Date.now();
//		this.model.section_1_attachment.push({id: 1, title: 'testx', file_id: 77});
	}
	
	onAttachmentRemoved(field, attachment){
//		const index = this.model.section_1_attachment.indexOf(attachment);
//		
//		if(index === -1){
//			return;
//		}
//		console.log(index);
//		this.model.section_1_attachment.splice(index, 1);
//		console.log(this.model.section_1_attachment);
//		this.$scope.editForm['upload_ts'].$setViewValue(Date.now());
	}
}